import { stepUrlsFirst, stepUrlsSecond } from "@/helpers/steps";
import { signOutThunk } from "@/server/thunks/thunks";
import { resetAction } from "@/store/action-creators";
import { store } from "@/store/store";
import { redirect } from "react-router-dom";

const avoidPages = ["/new_application-timer"];

export const checkAuthLoader = async () => {
  const { isAuth } = store.getState().authReducer;
  const { lastStep } = store.getState().stepsReducer;

  // нам не нужно слать клиента на шаги типа *-confirmation
  const isLastStepValid =
    lastStep &&
    !avoidPages.includes(lastStep) &&
    (Object.values(stepUrlsFirst).includes(lastStep) ||
      Object.values(stepUrlsSecond).includes(lastStep));

  const shouldReset = !isAuth || !isLastStepValid;

  if (!shouldReset) return redirect(lastStep);

  await store.dispatch(signOutThunk());
  localStorage.removeItem("turbo-zaim-state");
  store.dispatch(resetAction);

  return null;
};
